import { ProjectInformationRequest } from "../update-project/UpdateProjectRequest";

export type CreateProjectRequest = {
  projectInformation: ProjectInformationRequest;
};
